import type { models } from 'cesg-shared';
import { appHttpService } from '../standard/http-service';

class FortnoxUsersService {
  async getAll() {
    return await appHttpService.request
      .url('/fortnox-users')
      .get()
      .json<models.FortnoxUser[]>();
  }

  async getUserById(id: string) {
    return await appHttpService.request
      .url(`/fortnox-users/${id}`)
      .get()
      .json<models.FortnoxUser>();
  }

  async createGuestUser(details: models.CreateFortnoxGuestDetails) {
    return await appHttpService.request
      .url('/fortnox-users/guests')
      .post(details)
      .json<models.CreateFortnoxGuestResponse>();
  }
}
export const fortnoxUsersService = new FortnoxUsersService();
